<div class="main-container">
    <button
        class="day-select-button"
        (click)="onShowDropDownButtonClick()"
        [ngClass]="showDropDown ? 'active-day-select-button' : 'inactive-day-select-button'">
        <mat-icon class="small-icon" matPrefix>date_range</mat-icon>
        <div *ngIf="filterAllDays.ischeck">
            <span class="label">{{ filterAllDays.name  }}</span>
        </div>
        <div *ngIf="!filterAllDays.ischeck && daysSelection.length === 0">
            <span class="day-label-error">Selectionner au moins un jour</span>
        </div>
        <div class="layout-row" *ngIf="!filterAllDays.ischeck && daysSelection.length > 0">
            <div *ngFor="let day of daysSelection">
                <span class="day-label">{{ day.short }}</span>
            </div>
        </div>
        <mat-icon>arrow_drop_down</mat-icon>
    </button>
    <div class="dropdown" [ngClass]="showDropDown ? 'visible-dropdown' : 'invisible-dropdown'">
        <mat-checkbox
                class="tv-ns-blue-checkbox"
                [checked]="filterAllDays.ischeck"
                (change)="onSelectAllDaysChange()">
                {{ filterAllDays.name }}
            </mat-checkbox>
        <div class="horizontal-separator"></div>
        <div *ngFor="let filterDayToDisplay of filterDaysToDisplay">
            <mat-checkbox
                class="tv-ns-blue-checkbox"
                [value]="filterDayToDisplay.name"
                [checked]="filterDayToDisplay.ischeck === true"
                (change)="onSelectDaysChange(filterDayToDisplay)">
                {{filterDayToDisplay.name }}
            </mat-checkbox>
        </div>
    </div>
</div>